import { useCallback, useEffect, useState } from 'react';
import { Observable } from '@serviceos-rn/core';
const flexObs = new Observable(true);
export function useFlex(defaultValue) {
    const [flex, setFlex] = useState(typeof defaultValue === 'boolean' ? defaultValue : flexObs.value);
    useEffect(() => {
        typeof defaultValue === 'boolean' && flexObs.next(defaultValue);
        const sub = flexObs.subscribe(setFlex);
        return () => sub.unsubscribe();
    }, []);
    const handleSetFlex = useCallback((value) => {
        flexObs.next(value);
    }, []);
    return [flex, handleSetFlex];
}
